module.exports = __webpack_public_path__ + "static/media/Mapfre.093e2e54.jpg";